import React from 'react';
import { fetchHotGames } from '@/services/api';
import GameCards from '@/components/home/GameCards/GameCards';

/**
 * Hot Games Component
 * Displays trending/popular games from GIS API
 * Uses the reusable GameCards component
 */
const HotGames = () => {
  return (
    <GameCards
      title="Hot Games"
      fetchFunction={fetchHotGames}
      launchFunction={null}
      queryKey={['hotGames']}
      itemsPerPage={20}
    />
  );
};

export default HotGames;
